import { Capacitor } from '@capacitor/core';
import { externalNativeUrl, nativeBackAction } from './nativeNavigation';

/** No listeners or native plugin calls run in the website / Lovable preview. */
export async function initializeNativeRuntime(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  document.documentElement.classList.add('native-app');
  void import('@capacitor/splash-screen').then(({ SplashScreen }) => SplashScreen.hide());
  const [{ App }, { Browser }] = await Promise.all([
    import('@capacitor/app'),
    import('@capacitor/browser'),
  ]);

  if (Capacitor.getPlatform() === 'android') {
    await App.addListener('backButton', ({ canGoBack }) => {
      if (nativeBackAction(canGoBack) === 'back') window.history.back();
      else void App.minimizeApp();
    });
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || !(event.target instanceof Element)) return;
    const anchor = event.target.closest('a');
    if (!anchor || anchor.hasAttribute('download')) return;
    const url = externalNativeUrl(anchor.href, window.location.origin);
    if (!url) return;
    event.preventDefault();
    void Browser.open({ url }).catch(() => {
      // Never replace the app WebView when opening an external page fails.
      console.warn('External browser could not be opened.');
    });
  });
}